/*
    Avatar
*/

var avatar = document.getElementsByClassName('bot-avatar')[0];

// Avatar link
var avatarLink = document.getElementById('avatar-link');
avatarLink.addEventListener('change', function(event) {
    avatar.src = event.target.value;
    window.customJSON['avatar']['link'] = event.target.value;
})

// Avatar width
var avatarWidth = document.getElementById('avatar-width');
avatarWidth.addEventListener('change', function(event) {
    window.customStyle['.bot-avatar']['width'] = event.target.value + " !important";
    window.customStyle['#bot-neutral']['max-width'] = event.target.value + " !important";
    window.customStyle['#bot-emotion']['max-width'] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Avatar height
var avatarHeight = document.getElementById('avatar-height');
avatarHeight.addEventListener('change', function(event) {
    window.customStyle['.bot-avatar']['height'] = event.target.value + " !important";
    window.customStyle['#bot-neutral']['height'] = event.target.value + " !important";
    window.customStyle['#bot-emotion']['height'] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

/*
// Add JSON
var addJSON = document.getElementById('add-json');
var indexJson = 0;
addJSON.addEventListener('click', function() {
    
    // Input JSON
    var addJSONContainer = document.getElementById('add-json-container');

    var div = document.createElement('div');
    div.classList.add('settings-sub-block-content-line');

    var p = document.createElement('p');
    p.classList.add('settings-sub-block-content-line-label');

    var input = document.createElement('input');
    input.type = "text";
    input.placeholder = "add JSON";
    input.classList.add("addjson");
    input.setAttribute("data-id", indexJson);

    input.addEventListener('change', function(event) {
        window.customJSON['avatar']['animations'] = [];
        var addjson = document.getElementsByClassName('addjson');
        for (var i = 0; i < addjson.length; i++) {
            window.customJSON['avatar']['animations'][i] = addjson[i].value;
        }
    })

    // Remove JSON
    var removeJSON = document.createElement('div');
    removeJSON.classList.add("remove-json");
    removeJSON.setAttribute("data-id", indexJson);
    removeJSON.addEventListener('click', function(){
        var element = this;
        element.parentNode.remove();

        window.customJSON['avatar']['animations'] = [];
        var addjson = document.getElementsByClassName('addjson');
        for (var i = 0; i < addjson.length; i++) {
            window.customJSON['avatar']['animations'][i] = addjson[i].value;
        }
    })
    var newRemoveJSONLogo = document.createElement("div");
    newRemoveJSONLogo.classList.add("remove-json-logo");
    removeJSON.append(newRemoveJSONLogo);

    div.append(p);
    div.append(input);
    div.append(removeJSON);

    addJSONContainer.append(div);

    indexJson++;
})
*/